import { columns } from './utils';
import { taskList } from './request';
export default {
  data() {
    return {
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      tableData: [],
      setInterval: undefined
    };
  },
  created() {
    this.getListData();
    this.setInterval = setInterval(() => {
      this.getListData();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.setInterval);
  },
  methods: {
    async getListData() {
      let obj = {
        userId: this.$store.state.user.accountInfo.id,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      const {
        items,
        totalNum
      } = await taskList(obj);
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    onDownload(value) {
      if (value.downloadUrl) {
        let url = '';
        if (value.mark == 'overseas') {
          url = value.downloadUrl;
        } else {
          url = process.env.VUE_APP_File + value.downloadUrl;
        }
        console.log(process.env.VUE_APP_File, url);
        let a = document.createElement('a');
        a.href = url;
        a.download = value.taskName.replace('理赔列表', this.$t('理赔列表')).replace('订单列表', this.$t('订单列表')).replace('保单列表', this.$t('保单列表')) + '.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // downloadFileFun(url, 'application/vnd.ms-excel', value.taskName + '.xlsx');
      }
    }
  }
};